import { render, staticRenderFns } from "./PrivacyOptions.vue?vue&type=template&id=091ddf99"
import script from "./PrivacyOptions.vue?vue&type=script&lang=js"
export * from "./PrivacyOptions.vue?vue&type=script&lang=js"
import style0 from "./PrivacyOptions.vue?vue&type=style&index=0&id=091ddf99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports